import ClipboardContainer from "../../Componant/FormWidgets/Clipboard";

const Clipboard = () => {
  return (
    <div className="page-body">
      <ClipboardContainer />
    </div>
  );
};

export default Clipboard;
